export function getDateDifferenceInFrench(dateString, isWithMonths = true) {
  const givenDate = new Date(dateString);
  const today = new Date();

  let years = today.getFullYear() - givenDate.getFullYear();
  let months = today.getMonth() - givenDate.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  let parts = [];
  if (years > 0) parts.push(`${years} ${years > 1 ? 'ans' : 'an'}`);
  if (months > 0 & isWithMonths) parts.push(`${months} mois`);

  return parts.length > 0 ? parts.join(' ') : '0 mois';
}
